export const GPCLoaderConstants = {
    ACCESS_TOKEN: 'accessToken',
    LOADING: 'Loading',
    REDIRECTING: 'Redirecting.......',
    DEFAULT_EVALUATION_DOCID: '0',
    AUTH_TOKEN_REFRESH_LEAD_TIME_MS: 90000,
    TOKEN_PARSE_RETRY_DELAY_MS: 5000
};
//# sourceMappingURL=GPCLoaderConstants.js.map